<template>
  <FiltersWrapper>
    <CollapseBlock
      :class="['filters', {filters__margin: this.margin}]"
      tablet-mode
    >
      <div class="filters__item filters__item--resident">
        <CustomSelect
          fullWidth
          :options="this.residents"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :value="this.filters.resident_id"
          @change="(value, row) => onFiltersChange('resident_id', value, row)"
        />
      </div>
      <div class="filters__item filters__item--project-type">
        <CustomSelect
          fullWidth
          :options="this.projectTypes"
          label="Тип проекта"
          optionValueKey="project_type_id"
          optionLabelKey="project_type_name"
          :value="this.filters.project_type_id"
          @change="(value, row) => onFiltersChange('project_type_id', value, row)"
        />
      </div>
      <div class="filters__item filters__item--entrance">
        <CustomSelect
          fullWidth
          :options="this.entrances"
          label="Подъезд"
          optionValueKey="project_entrance_id"
          optionLabelKey="entrance_name"
          :loading="this.entrancesFetching"
          :value="this.filters.project_entrance_id"
          @change="(value, row) => onFiltersChange('project_entrance_id', value, row)"
        />
      </div>
      <slot
        :filters="this.filters"
        :onChange="this.onFiltersChange"
        :onDateChange="this.onDateChange"
      />
    </CollapseBlock>
  </FiltersWrapper>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import CollapseBlock from "@/components/common/CollapseBlock.vue";
import FiltersWrapper from "@/components/common/FiltersWrapper.vue";
import { getEntrances, getProjectTypes, getResidentialSettingsList } from "../BuildingSettings/services";

export default {
  name: "ProjectSettingsFilters",
  components: {CustomSelect, CollapseBlock, FiltersWrapper},
  props: ['filters', 'onChange', 'onDateChange', 'margin'],
  data() {
    return {
      residents: [],
      entrances: [],
      projectTypes: [],
      entrancesFetching: false,
    }
  },
  mounted() {
    this.getResidents()
    this.getProjectTypesData()
    if(this.filters.project_type_id && this.filters.resident_id)
      this.getEntrancesList(this.filters)
  },
  watch: {
    // Следим за изменениями фильтров (например, когда они восстанавливаются из URL)
    'filters.project_type_id': function(newVal, oldVal) {
      if(newVal && this.filters.resident_id && !oldVal) {
        this.getEntrancesList(this.filters)
      }
    }
  },
  methods: {
    async getResidents() {
      const res = await getResidentialSettingsList()
      this.residents = res || []
      // Эмитим событие после загрузки для обогащения selectedData
      this.$emit('residentsLoaded', this.residents)
    },
    async getProjectTypesData() {
      const res = await getProjectTypes()
      this.projectTypes = res || []
      // Эмитим событие после загрузки для обогащения selectedData
      this.$emit('projectTypesLoaded', this.projectTypes)
    },
    async getEntrancesList(filters) {
      this.entrancesFetching = true
      const res = await getEntrances(filters)
      this.entrancesFetching = false
      if(!res?.length) {
        this.entrances = []
        return
      }
      this.entrances = res
      // Эмитим событие после загрузки для обогащения selectedData
      this.$emit('entrancesLoaded', this.entrances)
    },

    onFiltersChange(key, value, row) {
      let editedRow = row ? {...row} : null
      if(key === 'resident_id') {
        if(!value) {
          this.projectTypes = []
          this.entrances = []
        }
      }
      if(key === 'project_type_id') {
        if(this.filters.resident_id) {
          value && this.getEntrancesList({...this.filters, [key]: value})
        }
        if(!value) {
          this.entrances = []
        }
      }
      if(key === 'project_entrance_id') {
        if(row) {
          const {entrance, ...others} = row
          editedRow = {...others}
        }
      }
      this.onChange(key, value, editedRow)
    },
  }
}
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 20px;

  &__margin {
    margin: 30px 0;
  }

  &__item {
    min-width: 150px;

    &--resident {
      flex: 1 1 300px;
      min-width: 300px;
      max-width: 480px;
    }

    &--project-type {
      flex: 2 1 400px;
      min-width: 400px;
      max-width: 640px;
    }

    &--entrance {
      flex: 1 1 300px;
      min-width: 300px;
      max-width: 480px;
    }

    :deep(.custom-select__wrapper) {
      width: 100%;
    }
  }
}
</style>
